<xena-table>
  <xena-row>
    <xena-column width="40%" i18n="@@import_csv_summary_reflected_name_all_lines">Total lines in the file</xena-column>
    <xena-cell>{{ summary.allLines }}</xena-cell>
  </xena-row>
  <xena-row>
    <xena-column i18n="@@import_csv_summary_reflected_name_chosen_lines">Chosen lines to import</xena-column>
    <xena-cell>{{ summary.chosenLines }}</xena-cell>
  </xena-row>
  <xena-row>
    <xena-column i18n="@@import_csv_summary_reflected_name_affected_resources">Affected resources</xena-column>
    <xena-cell>{{ summary.affectedResources }}</xena-cell>
  </xena-row>
  <xena-row>
    <xena-column i18n="@@import_csv_summary_reflected_name_activity_types">Affected activity types</xena-column>
    <xena-cell>{{ summary.affectedActivityTypes }}</xena-cell>
  </xena-row>
  <xena-row>
    <xena-column i18n="@@import_csv_summary_reflected_name_order_tasks">Affected order tasks</xena-column>
    <xena-cell>{{ summary.affectedOrderTasks }}</xena-cell>
  </xena-row>
</xena-table>
